import React from 'react';
import { Zap } from 'lucide-react';
import { useUserCredits } from '../../queries/user';
import { getRedirectUrl } from '../../utils/helpers';

// CreditsIndicator renders a compact "N / M posts" chip in the sidebar
// footer. When the user has no credits left, the chip becomes an
// inline CTA pointing to the products/upgrade page.
const CreditsIndicator = ({ onNavigate }) => {
  const { data, isLoading, isError } = useUserCredits();

  if (isLoading || isError || !data) {
    return null;
  }

  const { total = 0, used = 0, available = 0 } = data;
  const empty = available <= 0;
  const lowWatermark = total > 0 && available <= Math.max(1, Math.floor(total * 0.2));

  const accent = empty ? '#f59e0b' : lowWatermark ? '#f59e0b' : 'var(--accent)';
  const iconBg = empty
    ? 'rgba(251,191,36,0.15)'
    : lowWatermark
      ? 'rgba(251,191,36,0.15)'
      : 'var(--bg-card-alt)';

  const handleClick = () => {
    if (!empty) return;
    if (onNavigate) onNavigate();
    window.location.href = getRedirectUrl('/dashboard/products');
  };

  const Wrapper = empty ? 'button' : 'div';

  return (
    <Wrapper
      type={empty ? 'button' : undefined}
      onClick={empty ? handleClick : undefined}
      className='flex items-center gap-3 px-3 py-2.5 rounded-xl w-full text-left'
      style={{
        background: 'var(--bg-surface)',
        border: empty ? '1px dashed var(--border)' : '1px solid transparent',
        cursor: empty ? 'pointer' : 'default',
      }}
      aria-label={empty ? 'Buy more posts' : `${available} of ${total} post credits remaining`}
    >
      <div
        className='w-8 h-8 rounded-full flex items-center justify-center shrink-0'
        style={{ background: iconBg, color: accent }}
      >
        <Zap style={{ width: '1rem', height: '1rem' }} />
      </div>
      <div className='flex-1 min-w-0'>
        <p className='text-sm font-medium truncate' style={{ color: 'var(--text-primary)' }}>
          {empty ? 'Buy more posts' : `${available} / ${total} posts`}
        </p>
        <p className='text-xs' style={{ color: 'var(--text-ghost)' }}>
          {empty ? 'You ran out of credits' : `${used} used`}
        </p>
      </div>
    </Wrapper>
  );
};

export default CreditsIndicator;
